export const partsVideos = [
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [first part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/aa00af6e-ce12-45af-ba14-ee8d383f6dd1"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },

  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [second part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/cfcffa50-7a6a-4be8-a6eb-2ce2d2318ce0"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [third part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/cd9d9a38-cb50-4daa-a968-5e849e645060"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [Fourth part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/fefcd14c-0bea-4f03-9837-d2549c03ee28"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [fifth part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/45e20a6f-b41c-478d-91a6-83c7a3490c86"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [sixth part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/83c0f899-ee88-4ea3-b82b-d791f143636b"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },

  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [seventh part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/6bd00b1f-b5d7-4203-a44d-357c504dddf8"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },

  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [eight part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/413b2c82-3edf-4458-a6d5-693ee0bb582d"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [ninth part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/57ebd7d1-909f-41f1-80c0-76eed1e66ebc"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [tenth part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/878848f8-873e-4c39-8721-dc6dc253bf90"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
  {
    video: (
      <iframe
        title="TecCEM: Parts Showcase [eleventh part] (2022) [English]"
        width="800"
        height="400"
        src="https://video.igem.org/videos/embed/7eb55084-f1c1-485e-80f5-783540caf2cf"
        frameborder="0"
        allowfullscreen=""
        sandbox="allow-same-origin allow-scripts allow-popups"
      ></iframe>
    ),
  },
];
